export default "__VITE_ASSET__D84LMNt___"